module.exports = __webpack_public_path__ + "media/images/redesign-images/textures/texture-4-6bc02c4c8fa622754aea328ee3154011.svg";